module.exports = __webpack_public_path__ + "static/img/14.129fb7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/14.png
// module id = w+3p
// module chunks = 0